/**
 * Progress marker for the pre-checkout onboarding flow (PREC-3653).
 * Mirrors the API's EOnboardingStep — used to resume an interrupted
 * onboarding at the right screen.
 */
export enum EOnboardingStep {
	PROFILE = "PROFILE",
	CHAT = "CHAT",
	LISTS = "LISTS",
	TRACK = "TRACK",
	/** The WHEN/WHY/WHAT priming chat between Track and checkout (PREC-3712). */
	PRIME = "PRIME",
	CHECKOUT = "CHECKOUT",
	DONE = "DONE",
}
